export const editorTheme = {
    paragraph: 'gfu-editor__paragraph gfu-editor-body',
    heading: {
        h2: 'gfu-editor__heading gfu-editor-heading gfu-editor-heading--heading',
        h3: 'gfu-editor__heading gfu-editor-heading gfu-editor-heading--subheading',
        h4: 'gfu-editor__heading gfu-editor-heading gfu-editor-heading--caption',
    },
    quote: 'gfu-editor__quote gfu-editor-quote',
    list: {
        ol: 'gfu-editor__list gfu-editor-list gfu-editor-list--ordered',
        ul: 'gfu-editor__list gfu-editor-list gfu-editor-list--unordered',
        listitem: 'gfu-editor__listitem gfu-editor-list__item',
        nested: {
            listitem: 'gfu-editor-list__item--nested',
        },
    },
    text: {
        bold: 'gfu-editor-text--bold',
        italic: 'gfu-editor-text--italic',
        underline: 'gfu-editor-text--underline',
        strikethrough: 'gfu-editor-text--strikethrough',
        underlineStrikethrough: 'gfu-editor-text--underline-strikethrough',
    },
    link: 'gfu-editor-link',
};
